import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelpMessagesService {
  data = [
    {
      name: 'confirmNumber',
      title: 'تایید شماره موبایل',
      msg: 'مشتری گرامی، جهت ورود به موبایل بانک، نیاز است شماره تلفن وارد شده را تایید بفرمایید. هم اکنون پیامکی حاوی کد فعال‌سازی به شماره تلفن همراه شما ارسال شده است. لطفا کد دریافتی را در قسمت مربوطه وارد نمایید. در صورتی که کدی دریافت نکردید، پس از یک دقیقه می توانید با لمس "ارسال مجدد"، درخواست ارسال مجدد کد فعال سازی نمایید.',
    },
    {
      name: 'register',
      title: 'صفحه ثبت نام',
      msg: 'جهت ورود به موبایل بانک، نیاز است شماره موبایل همراه شما تایید شود. با وارد نمودن شماره تلفن همراه خود، کد فعال‌سازی برای شما ارسال می‌گردد که در مرحله بعد با واردنمودن کد می‌توانید به موبایل بانک وارد شوید.',
    },
    {
      name: 'loginpage',
      title: 'صفحه ورود',
      // msg: 'مشتری گرامی، برای ورود به موبایل بانک اقتصاد‌نوین، نیاز است شماره مشتری و رمز عبور موبایل‌ بانک خود را وارد نمایید. در‌صورتی‌که تا‌کنون نسبت به دریافت رمز موبایل ‌بانک اقدام نکرده‌اید، با مراجعه به نزیک‌ ترین شعبه بانک اقتصاد‌نوین اطلاعات لازم را دریافت کنید؛ تا زمان دریافت رمز عبور خود، می‌توانید با‌ لمس کلید "خدمات کارت" از امکانات متنوع کارتی این اپلیکیشن استفاده کرده یا از قسمت شعب، آدرس نزدیک ترین شعبه را بیابید.',
      msg: '\n' +
        'برای ورود به موبایل بانک اقتصادنوین شماره مشتری و رمز عبور موبایل بانک خود را وارد نمایید.\n' +
        'برای دریافت رمز درصورتی‌که پیش‌ از این شماره همراه خود را در بانک ثبت کرده و رمز دوم ایستای کارت خود را دریافت نموده‌اید، به‌صورت ' +
        '' + `<a href="https://modern.enbank.ir/netway/userAccount/YAGHUT-MOBILE-APPLICATION/resetPassword" target="_blank">غیرحضوری ثبت‌نام</a>` +
        ' و یا به شعب بانک اقتصادنوین در سراسر کشور مراجعه نمایید.\n' +
        '\n'
    },
    {
      name: 'cardtransfer',
      title: 'سرویس انتقال کارت به کارت',
      msg: 'به منظور انتقال وجه کارت به کارت، پس از انتخاب کارت‌مبدا، شماره کارت مقصد را وارد کنید. در‌صورتی‌که اطلاعات کارت مقصد پیش از این در موبایل بانک ذخیره شده است، با لمس تصویر مرتبط می‌توانید کارت مورد‌نظر را انتخاب کنید.\n' +
        'لازم است توجه داشته باشید کارت به کارت به مقصد سایر بانک‌ها مشمول کسر کارمزد مطابق قوانین بانک مرکزی است.\n',
    },
    {
      name: 'balance',
      title: 'سرویس موجودی',
      msg: 'برای دریافت موجودی کارت خود، کارت مورد‌نظر را از میان کارت‌ها انتخاب کرده و به تناسب مورد، رمز دوم کارت، CVV2  و تاریخ انقضای کارت را وارد کنید.\n' +
        'دریافت موجودی کارت بانک‌های غیر از اقتصاد‌نوین، مطابق قوانین بانک مرکزی مشمول کارمزد خواهد بود.\n'
    },
    {
      name: 'invoice',
      title: 'سرویس صورت حساب',
      msg: 'برای دریافت صورت‌حساب کارت خود، کارت مورد‌نظر را از میان کارت‌ها انتخاب کرده و به تناسب مورد، رمز دوم کارت، CVV2  و تاریخ انقضای کارت را وارد کنید.\n' +
        'دریافت صورت‌حساب کارت بانک‌های غیر از اقتصاد‌نوین، مطابق قوانین بانک مرکزی مشمول کارمزد خواهد بود.\n'
    },
    {
      name: 'chargecode',
      title: 'سرویس خرید شارژ',
      msg: 'خرید کد شارژ برای اپراتورهای مختلف از طریق این سرویس امکان‌پذیر است. به این منظور پس از وارد کردن اپراتور شماره تلفن همراه موردنظر، می‌توانید نوع شارژ خود را انتخاب کنید.'

    },
    {
      name: 'immediatecharge',
      title: 'سرویس خرید شارژ',
      msg: 'خرید شارژ برای اپراتورهای مختلف از طریق این سرویس امکان‌پذیر است. به این منظور پس از وارد کردن شماره تلفن همراه موردنظر، می‌توانید نوع شارژ خود را انتخاب کنید. اپراتور تلفن همراه شما به‌ صورت خودکار تشخیص داده می‌شود. سیم کارت های ترابرد شده نمی توانند از این سرویس بهره مند شوند. این کاربران می توانند از سرویس خرید کد شارژ استفاده نمایند'
    },
    {
      name: 'addnewcard',
      title: 'راهنما',
      msg: 'خرید شارژ برای اپراتورهای مختلف از طریق این سرویس امکان پذیر است. به این منظور پس از وارد کردن شماره تلفن همراه مورد نظر، می توانید نوع شارژ خود را انتخاب کنید. \n اپراتور تلفن همراه شما به صورت خودکار تشخیص داده می شود. سیم کارت های ترابرد شده نمی توانند از این سرویس بهره مند شوند. این کاربران می توانند از سرویس خرید کد شارژ استفاده کنند'

    },
    {
      name: 'deposittransfer',
      title: 'سرویس انتقال سپرده به سپرده',
      msg: 'جهت انتقال وجه به سایر حساب‌های بانک اقتصاد نوین، پس از انتخاب سپرده‌ی مبدأ، نسبت به وارد کردن شماره سپرده‌ی مقصد و مبلغ مورد نظر اقدام نمایید. در صورتیکه اطلاعات سپرده‌ی مقصد پیش از این در موبایل بانک ذخیره شده است، با لمس تصویر مرتبط، می‌توانید سپرده مورد نظر را انتخاب نمایید.'
    },
    {
      name: 'ibantransfer',
      title: 'سرویس انتقال وجه بین بانکی ',
      msg: 'جهت انتقال وجه بین بانکی، نسبت به وارد کردن شماره شبای مقصد و مبلغ مورد نظر اقدام نمایید. در صورتیکه اطلاعات شبای مقصد پیش از این در موبایل بانک ذخیره شده است، با لمس تصویر مرتبط، شبای مورد نظر را انتخاب نمایید.'
    },
    {
      name: 'billPayment',
      title: 'سرویس پرداخت قبض',
      msg: 'کلیه قبوض اعم از آب، برق، گاز،  تلفن همراه، تلفن ثابت، جرایم رانندگی، عوارض شهرداری و خدمات عمومی از طریق همراه نوین قابل پرداخت است.' +
      'به منظور پرداخت قبض، پس از انتخاب کارتی/حسابی که با آن قصد پرداخت دارید، شناسه قبض و شناسه پرداخت را وارد کرده و کلید "تایید" را لمس کنید .'
    },
    {
      name: 'etfHelp',
      title: 'قوانین و مقررات',
      msg: 'پذیره‌نویسی واحدهای سرمایه‌گذاری صندوق سرمایه‌گذاری قابل معامله (ETF) واسطه‌گری مالی یکم برای واگذاری باقیمانده سهام دولت در بانک‌های ملت، تجارت و صادرات ایران و بیمه‌های البرز و اتکایی امین: \n' +
      'الف) مقررات عمومی پذیره نویسی:\n' +
      '- پذیره‌نویسی صرفاً شامل اشخاص حقیقی ایرانی است و تا ساعت ۲۴ آخرين روز اردیبهشت ماه ۹۹ ادامه خواهد داشت.\n' +
      '- هر فرد دارای کد ملی بدون محدودیت سنی تا سقف ۲۰ میلیون ریال امکان خرید سهام دارد. \n' +
      '- قیمت هر سهام صندوق با احتساب ۲۰ درصد تخفیف لحاظ شده که ۵ درصد از آن به عنوان دارایی سرمایه گذاران و به منظور انجام عملیات بازارگردانی نزد صندوق نگهداری خواهد شد.\n' +
      '- داشتن کد معاملاتی (کد بورسی) برای پذیره نویسی الزامی نیست.\n' +
      '- معامله واحدهای سهام صرفاً از ۲ ماه بعد از تخصیص امکان‌پذیر است، ولی سهامدار بایست تا آن زمان نسبت به ثبت‌نام در سامانه سجام و دریافت کد معاملاتی (کد بورسی) مطابق رویه‌های شرکت سپرده‌گذاری مرکزی و تسویه وجوه اقدام نمایند.\n' +
      '- داشتن حساب به ازای هر کد ملی الزامی نیست؛ لیکن شماره شبای پرداخت کننده برای عودت وجوه مازاد بر واحدهای تخصیص یافته پس از اتمام پذیره‌نویسی نیاز خواهد بود.\n' +
      'تبصره (1): عودت وجوه به هر دلیل از جمله اضافه پرداختی و مازاد ناشی از تسهیم بالنسبه توسط صندوق صرفاً به شماره شبای پرداخت کننده صورت می‌پذیرد. \n' +
      'تبصره (2): حقوق مالکانه واحدهای سرمایه‌گذاری، متعلق به اشخاص حقیقی است که پذیره نویسی بر مبنای کد ملی آن‌ها صورت گرفته است.\n' +
      '- حداکثر مبلغ پذیره‌نویسی معادل ۲۰ میلیون ريال (۲۰۰ سهم ۱۰۰ هزار ریالی) است.\n' +
      'ب) سلب مسئولیت: \n' +
      'در صورت انجام پذیره‌نویسی برای یک کد ملی از طرق دیگر به نحو که مجموع مبلغ بالاتر از ۲۰ میلیون ريال شود، عودت وجه پس از پایان زمان پذیره‌نویسی قابل انجام بوده و مستلزم طی شدن مراحل قانونی است و زمان‌بر خواهد بود.\n' +
      '- بانک اقتصاد نوین و اپلیکیشن‌های زیرمجموعه آن، صرفاً وظیفه پذیره‌نویسی واحدهای سرمایه‌گذاری صندوق را به عهده داشته و بنابراین پس از واریز وجه،ادعایی علیه آنها معتبر نخواهد بود و لذا مراتب توسط ثبت‌نام کننده به شرح مندرج در اطلاعیه‌های پذیره‌نویسی پیگیری خواهد شد.\n' +
      '- مسئولیت صحت کلیه اطلاعات اعلامی در فرآیند پذیره نویسی بر عهده ثبت‌نام کننده است.\n' +
      '- کلیه اطلاعات اعلامی در مراحل ثبت نام شامل کدپستی محل اقامت و شماره تلفن همراه به شرح فوق، متعلق و یا در اختیار اینجانب بوده و ارسال هرگونه ابلاغیه، اخطار، پیام، مراسلات و مکاتبه با نشانی اعلام شده به طرق مذکور به منزله ابلاغ به اینجانب تلقى شده و مسئولیت سوء استفاده از اطلاعات ارسال صرفاً بر عهده کاربر است.\n'
    },
    {
      name: 'package',
      title: 'بسته اینترنتی',
      msg: 'خرید بسته اینترتنی برای اپراتورهای مختلف از طریق این سرویس امکان پذیر است. به این منظور پس از وارد نمودن شماره تلفن همراه مورد نظر، اپراتور و نوع سیم کارت، می توانید نوع بسته خود را انتخاب نمایید.'
    },
    {
      name: 'changePass',
      title: 'تغییر رمز شماره مشتری',
      msg: 'جهت تغییر رمز شماره مشتری، رمز فعلی خود و رمز جدید مورد نظر را وارد کرده و کلید "تغییر" را لمس نمایید. توجه داشته باشید پس از تغییر موفق رمز عبور، رمز قبلی غیر فعال شده و در دفعات بعدی ورود، می بایست رمز جدید را وارد نمایید.'
    },
    {
      name: 'addNewCard2',
      title: 'کارت جدید',
      msg: 'برای تعریف کارت جدید در موبایل بانک اقتصاد نوین، شماره کارت، نام دلخواه، ماه و سال را وارد نمایید.'
    }
];
  getData(name) {
    return this.data.filter( x => x.name === name)[0];
  }
}
